module.exports = __webpack_public_path__ + "img/mp.19d23368.svg";